import { baseApi } from './baseApi'

export type ReaderAppVersion = {
  id: string
  type: 'bin' | 'script'
  version: string
  s3FileKey: string
  createdAt: string
  deletedAt?: string | null
}

export type CreateReaderAppVersionRequest = {
  version: string
  type: 'bin' | 'script'
  s3FileKey: string
}

export const readerAppsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReaderAppVersions: builder.query<ReaderAppVersion[], void>({
      query: () => ({ url: '/lab/reader-apps/app' }),
      providesTags: ['ReaderAppVersions'],
    }),
    createReaderAppVersion: builder.mutation<{ message: string }, CreateReaderAppVersionRequest>({
      query: (body) => ({
        url: '/lab/reader-apps/app',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ReaderAppVersions'],
    }),
    deleteReaderAppVersion: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `/lab/reader-apps/app/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ReaderAppVersions'],
    }),
  }),
})

export const {
  useGetReaderAppVersionsQuery,
  useCreateReaderAppVersionMutation,
  useDeleteReaderAppVersionMutation,
} = readerAppsApi
